import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "diagram-editor-cell diagram-editor-cell--header-edits"
};
const _hoisted_2 = {
  class: "panel-title"
};
const _hoisted_3 = {
  class: "panel-title-block"
};
const _hoisted_4 = {
  class: "panel-title"
};
const _hoisted_5 = {
  key: 0,
  class: "header-actions"
};
const _hoisted_6 = {
  key: 1,
  class: "diagram-editor-cell diagram-editor-cell--body-edits"
};
const _hoisted_7 = {
  class: "diagram-conversation-block"
};
const _hoisted_8 = {
  key: 0,
  class: "empty-chat-state"
};
const _hoisted_9 = {
  class: "empty-title"
};
const _hoisted_10 = {
  class: "empty-subtitle"
};
const _hoisted_11 = {
  key: 1,
  class: "diagram-messages",
  ref: "messagesContainer"
};
const _hoisted_12 = {
  key: 0,
  class: "message-spinner"
};
const _hoisted_13 = {
  key: 0,
  class: "user-msg-bubble"
};
const _hoisted_14 = {
  key: 0,
  class: "message-files-container"
};
const _hoisted_15 = {
  key: 1,
  class: "message-text"
};
const _hoisted_16 = {
  key: 1,
  class: "message-text"
};
const _hoisted_17 = {
  key: 0,
  class: "uploaded-files-preview"
};
const _hoisted_18 = {
  class: "slot-container"
};
const _hoisted_19 = {
  key: 0,
  class: "file-processing-spinner"
};
const _hoisted_20 = {
  class: "diagram-editor-cell diagram-editor-cell--body-preview"
};
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = {
  key: 1,
  class: "diagram-empty-state"
};
const _hoisted_23 = {
  class: "empty-title"
};
const _hoisted_24 = {
  class: "empty-subtitle"
};
const _hoisted_25 = {
  class: "dialog-body"
};
const _hoisted_26 = {
  class: "diagram-help-dialog-body-preamble"
};
const _hoisted_27 = {
  class: "diagram-help-dialog-body-instructions"
};
const _hoisted_28 = {
  class: "diagram-help-dialog-body-instructions-title diagram-help-dialog-body-title-block"
};
const _hoisted_29 = {
  class: "diagram-help-dialog-body-instructions-detail diagram-help-dialog-body-detail-block"
};
const _hoisted_30 = ["innerHTML"];
const _hoisted_31 = {
  class: "diagram-help-dialog-body-instructions-examples"
};
const _hoisted_32 = {
  class: "diagram-help-dialog-body-instructions-examples-title diagram-help-dialog-body-title-block"
};
const _hoisted_33 = ["innerHTML"];
const _hoisted_34 = {
  class: "diagram-help-dialog-body-complt-instructions"
};
const _hoisted_35 = {
  class: "diagram-help-dialog-body-complt-instructions-title diagram-help-dialog-body-title-block"
};
const _hoisted_36 = {
  class: "diagram-help-dialog-body-complt-instructions-detail diagram-help-dialog-body-detail-block"
};
const _hoisted_37 = {
  class: "dialog-footer"
};
const _hoisted_38 = {
  class: "discard-changes-dialog-body"
};
const _hoisted_39 = {
  class: "discard-changes-dialog-body-content"
};
const _hoisted_40 = {
  class: "new-diagram-dialog-body"
};
const _hoisted_41 = {
  class: "new-diagram-dialog-body-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_loader = _resolveComponent("loader");
  const _component_w_input = _resolveComponent("w-input");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_icon_button = _resolveComponent("icon-button");
  const _component_pan_zoom_viewer = _resolveComponent("pan-zoom-viewer");
  const _component_w_dialog = _resolveComponent("w-dialog");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(["diagram-editor-container", {
      'diagram-editor-container--view': !_ctx.isEditing
    }])
  }, [_ctx.isEditing ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('diagramEditor.editsTitle')), 1), _createVNode(_component_w_tool_tip, {
    text: _ctx.$t('diagramEditor.confidentialTooltip'),
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      class: "tooltip-icon",
      icon: "information-outline"
    })]),
    _: 1
  }, 8, ["text"])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(['diagram-editor-cell diagram-editor-cell--header-preview', {
      'is-editing': _ctx.isEditing
    }])
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('diagramEditor.previewTitle')), 1), _ctx.isEditing && (_ctx.hasUnsavedChanges || _ctx.diagramSaved) ? (_openBlock(), _createBlock(_component_w_tool_tip, {
    key: 0,
    text: _ctx.diagramEditStatus,
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      class: _normalizeClass(['tooltip-icon', {
        'unsaved-changes-tooltip': _ctx.hasUnsavedChanges
      }]),
      icon: _ctx.diagramEditStatusIcon
    }, null, 8, ["class", "icon"])]),
    _: 1
  }, 8, ["text"])) : _createCommentVNode("", true)]), !_ctx.hideActionsButtons ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_ctx.isEditing ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createVNode(_component_standard_button, {
    class: "btn-action",
    outlined: true,
    disabled: !_ctx.canDownloadPng,
    onAction: _cache[0] || (_cache[0] = $event => _ctx.downloadDiagramAsPng())
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      class: "btn-icon",
      icon: "download-outline"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('diagramEditor.downloadPngBtn')), 1)]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_standard_button, {
    class: "btn-action",
    outlined: true,
    disabled: _ctx.isProcessing || !_ctx.currentD2Code?.length,
    onAction: _cache[1] || (_cache[1] = $event => _ctx.discardChanges())
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('diagramEditor.cancelBtn')), 1)]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_standard_button, {
    class: "btn-action",
    disabled: !_ctx.hasUnsavedChanges || _ctx.isProcessing,
    onAction: _cache[2] || (_cache[2] = $event => _ctx.saveDiagram())
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      class: "btn-icon",
      icon: "check"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('diagramEditor.saveBtn')), 1)]),
    _: 1
  }, 8, ["disabled"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createVNode(_component_standard_button, {
    class: "btn-action",
    outlined: true,
    onAction: _cache[3] || (_cache[3] = $event => _ctx.displayNewDiagramConfirmationModal())
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      class: "btn-icon",
      icon: "plus"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('diagramEditor.newDiagramBtn')), 1)]),
    _: 1
  }), _createVNode(_component_standard_button, {
    class: "btn-action",
    outlined: true,
    onAction: _cache[4] || (_cache[4] = $event => _ctx.editDiagram())
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      class: "btn-icon",
      icon: "pencil-outline"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('diagramEditor.editBtn')), 1)]),
    _: 1
  })], 64))])) : _createCommentVNode("", true)], 2), _ctx.isEditing ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_ctx.showEmptyChatPlaceholder ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_icon, {
    class: "empty-chat-state-icon",
    icon: "message-reply-text-outline"
  }), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('diagramEditor.emptyChatTitle')), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('diagramEditor.emptyChatSubtitle')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_ctx.isProcessing ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_loader, {
    "spinner-size": 'spinnersMedium'
  })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reversedMessages, (msg, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["diagram-message", msg.role])
    }, [msg.role === 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [msg.filesMeta?.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.filesMeta, fileMeta => {
      return _openBlock(), _createElementBlock("div", {
        key: fileMeta.name,
        class: "message-single-file-container"
      }, [_createVNode(_component_w_tool_tip, {
        text: fileMeta.name,
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: _ctx.getSelectedFileIcon(fileMeta.type),
          class: "uploaded-file-icon",
          color: "black"
        }, null, 8, ["icon"])]),
        _: 2
      }, 1032, ["text"])]);
    }), 128))])) : _createCommentVNode("", true), msg.text ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(msg.text), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(msg.text), 1)), _createVNode(_component_w_tool_tip, {
      text: _ctx.$t('diagramEditor.messageError'),
      placement: "top"
    }, {
      default: _withCtx(() => [msg.errorOccurred ? (_openBlock(), _createBlock(_component_icon, {
        key: 0,
        icon: "alert-circle-outline",
        class: "message-error-flag"
      })) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["text"])], 2);
  }), 128))], 512))]), _ctx.selectedFiles.length ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFiles, file => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: file.raw?.uid
    }, [file.raw ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(['uploaded-file-icon-container', {
        'file-icon-disabled': _ctx.isProcessing
      }])
    }, [_createVNode(_component_w_tool_tip, {
      text: file.raw.name,
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_icon, {
        icon: _ctx.getSelectedFileIcon(file.raw.type),
        class: _normalizeClass(['uploaded-file-icon', {
          'is-file-processing': _ctx.isExtractionProcessing(file)
        }]),
        color: _ctx.isExtractionFailed(file) ? 'red' : 'black',
        disabled: _ctx.isProcessing
      }, null, 8, ["icon", "class", "color", "disabled"]), _createVNode(_component_standard_button, {
        class: _normalizeClass(['uploaded-file-delete-btn', {
          'is-error': _ctx.isExtractionFailed(file)
        }]),
        outlined: true,
        disabled: _ctx.isProcessing,
        onClick: $event => _ctx.removeSelectedFile(file)
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "delete-outline"
        })]),
        _: 1
      }, 8, ["class", "disabled", "onClick"]), _ctx.isExtractionProcessing(file) ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_19, null, 512)), [[_directive_loading, true]]) : (_openBlock(), _createBlock(_component_icon, {
        key: 1,
        icon: _ctx.getExtractionResultIcon(file),
        class: _normalizeClass(_ctx.getExtractionResultClass(file))
      }, null, 8, ["icon", "class"]))])]),
      _: 2
    }, 1032, ["text"])], 2)) : _createCommentVNode("", true)], 64);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(['diagram-chat-input-block', {
      'is-disabled': _ctx.isProcessing
    }])
  }, [_createVNode(_component_w_input, {
    modelValue: _ctx.chatInputValue,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.chatInputValue = $event),
    type: 'textarea',
    class: _normalizeClass(['chat-user-textarea-input', {
      'is-dragging-over': _ctx.isDraggingOverTextArea
    }]),
    rows: 3,
    resize: "none",
    disabled: _ctx.isProcessing,
    placeholder: _ctx.$t(_ctx.inputPlaceholderKey),
    onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers($event => _ctx.sendMessage(), ["exact", "prevent"]), ["enter"])),
    onDragover: _cache[7] || (_cache[7] = $event => _ctx.isDraggingOverTextArea = true),
    ref: "diagramChatInput"
  }, null, 8, ["modelValue", "class", "disabled", "placeholder"]), _createVNode(_component_w_tool_tip, {
    text: _ctx.$t('diagramEditor.helpBtnTooltip'),
    placement: "top",
    width: "100",
    "popper-class": "diagram-gen-help-btn-tooltip-popper"
  }, {
    default: _withCtx(() => [_createVNode(_component_standard_button, {
      class: "help-btn",
      outlined: true,
      onAction: _cache[8] || (_cache[8] = $event => _ctx.showHelpModal())
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "help-circle-outline"
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["text"]), _createVNode(_component_el_upload, {
    drag: "",
    class: "file-upload-field",
    "file-list": _ctx.selectedFiles,
    "onUpdate:fileList": _cache[9] || (_cache[9] = $event => _ctx.selectedFiles = $event),
    accept: _ctx.acceptedFilesTypes,
    disabled: _ctx.isProcessing,
    "show-file-list": false,
    multiple: "",
    "on-success": _ctx.onFileUpload,
    onDragleave: _cache[10] || (_cache[10] = $event => _ctx.isDraggingOverTextArea = false)
  }, {
    default: _withCtx(() => [_createVNode(_component_w_tool_tip, {
      text: _ctx.$t('diagramEditor.filesUploadBtnTooltip'),
      placement: "top",
      width: "100",
      "popper-class": "diagram-gen-upload-btn-tooltip-popper"
    }, {
      default: _withCtx(() => [_createVNode(_component_standard_button, {
        class: "files-upload-btn",
        outlined: true,
        disabled: _ctx.isProcessing
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "upload-outline"
        })]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    }, 8, ["text"])]),
    _: 1
  }, 8, ["file-list", "accept", "disabled", "on-success"]), _createVNode(_component_w_tool_tip, {
    text: _ctx.$t('diagramEditor.sendBtnTooltip'),
    placement: "top",
    width: "100",
    "popper-class": "diagram-gen-send-btn-tooltip-popper"
  }, {
    default: _withCtx(() => [_createVNode(_component_icon_button, {
      class: "send-btn",
      disabled: !_ctx.canSendMsg,
      icon: "arrow-up",
      onClick: _cache[11] || (_cache[11] = $event => _ctx.sendMessage())
    }, null, 8, ["disabled"])]),
    _: 1
  }, 8, ["text"])], 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['diagram-viewport', {
      'is-loading': _ctx.isProcessing
    }])
  }, [_ctx.diagramSVG ? (_openBlock(), _createBlock(_component_pan_zoom_viewer, {
    key: 0,
    ref: "panzoomViewerComponent",
    "buttons-position": "bottom-right"
  }, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.diagramSVG
    }, null, 8, _hoisted_21)]),
    _: 1
  }, 512)) : !_ctx.currentD2Code?.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_icon, {
    class: "diagram-empty-state-icon",
    icon: "sitemap-outline"
  }), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('diagramEditor.emptyPreviewTitle')), 1), _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('diagramEditor.emptyPreviewSubtitle')), 1)])) : _createCommentVNode("", true)], 2)), [[_directive_loading, _ctx.currentD2Code?.length && !_ctx.diagramSVG]])])], 2), _ctx.displayDiagramHelpDialog ? (_openBlock(), _createBlock(_component_w_dialog, {
    key: 0,
    visible: true,
    class: "diagram-editor-help-dialog",
    title: _ctx.$t('diagramEditor.helpDialog.title'),
    onOnDialogClose: _cache[13] || (_cache[13] = $event => _ctx.closeDiagramHelpDialog())
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_37, [_createVNode(_component_standard_button, {
      label: _ctx.$t('diagramEditor.helpDialog.footerBtn'),
      outlined: true,
      onAction: _cache[12] || (_cache[12] = $event => _ctx.closeDiagramHelpDialog())
    }, null, 8, ["label"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('diagramEditor.helpDialog.body.preamble')), 1), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_icon, {
      class: "diagram-help-titles-icon",
      icon: "forum-outline"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('diagramEditor.helpDialog.body.instructions.title')), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("ul", {
      class: "diagram-help-instruction-item",
      innerHTML: _ctx.$t('diagramEditor.helpDialog.body.instructions.detail')
    }, null, 8, _hoisted_30)]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('diagramEditor.helpDialog.body.instructions.examples.title')), 1), _createElementVNode("div", {
      class: "diagram-help-dialog-body-instructions-examples-detail diagram-help-dialog-body-detail-block",
      innerHTML: _ctx.$t('diagramEditor.helpDialog.body.instructions.examples.detail')
    }, null, 8, _hoisted_33)])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_icon, {
      class: "diagram-help-titles-icon",
      icon: "lightbulb-on-outline"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('diagramEditor.helpDialog.body.compltInstructions.title')), 1)]), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('diagramEditor.helpDialog.body.compltInstructions.detail')), 1)])])]),
    _: 1
  }, 8, ["title"])) : _createCommentVNode("", true), _ctx.displayDiscardConfirmationDialog ? (_openBlock(), _createBlock(_component_confirm_dialog, {
    key: 1,
    title: _ctx.$t('diagramEditor.discardChangesDialog.title'),
    "confirm-button-text": _ctx.$t('diagramEditor.discardChangesDialog.confirmBtn'),
    "cancel-button-text": _ctx.$t('diagramEditor.discardChangesDialog.cancelBtn'),
    visible: true,
    "highlight-confirm-button": true,
    class: "discard-changes-dialog",
    onOnConfirmed: _cache[14] || (_cache[14] = $event => _ctx.cancelChanges()),
    onOnDialogClose: _cache[15] || (_cache[15] = $event => _ctx.closeDiscardConfirmationModal()),
    onOnCanceled: _cache[16] || (_cache[16] = $event => _ctx.closeDiscardConfirmationModal())
  }, {
    message: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createVNode(_component_icon, {
      class: "discard-changes-dialog-body-icon diagram-dialog-alert-icon",
      icon: "alert-circle-outline"
    }), _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t('diagramEditor.discardChangesDialog.confirmMsg')), 1)])]),
    _: 1
  }, 8, ["title", "confirm-button-text", "cancel-button-text"])) : _createCommentVNode("", true), _ctx.displayNewDiagramConfirmationDialog ? (_openBlock(), _createBlock(_component_confirm_dialog, {
    key: 2,
    title: _ctx.$t('diagramEditor.newDiagramDialog.title'),
    "confirm-button-text": _ctx.$t('diagramEditor.newDiagramDialog.confirmBtn'),
    "cancel-button-text": _ctx.$t('diagramEditor.newDiagramDialog.cancelBtn'),
    visible: true,
    "highlight-confirm-button": true,
    class: "new-diagram-dialog",
    onOnConfirmed: _cache[17] || (_cache[17] = $event => _ctx.confirmNewDiagram()),
    onOnDialogClose: _cache[18] || (_cache[18] = $event => _ctx.closeNewDiagramConfirmationModal()),
    onOnCanceled: _cache[19] || (_cache[19] = $event => _ctx.closeNewDiagramConfirmationModal())
  }, {
    message: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createVNode(_component_icon, {
      class: "new-diagram-dialog-body-icon diagram-dialog-alert-icon",
      icon: "alert-circle-outline"
    }), _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t('diagramEditor.newDiagramDialog.confirmMsg')), 1)])]),
    _: 1
  }, 8, ["title", "confirm-button-text", "cancel-button-text"])) : _createCommentVNode("", true)], 64);
}